<div class="modal-header">
  <div class="text-wrap">
      <!-- <p class="body2 black-color font-400">Filter by</p> -->
  </div>
  <button type="button" class="btn btnIcon" (click)="closeModal()">
      <img src="./assets/images/close.svg" class="btn-icon" alt="close"/>
  </button>
</div>
<div class="modal-body">
  <div class="text-wrap">
    <p class="body1 text-center black-color font-medium mb-2">
      {{message}}
    </p>
  </div>
</div>  
<div class="modal-footer no-border pb-5">
  <div class="w-100 d-flex justify-content-center">
      <button class="btn btnThemeOutline blue me-3" (click)="closeModal()" *ngIf="ClosebtnLabel">
          {{ClosebtnLabel}}
      </button>
      <button type="button" class="btn btnTheme blue" (click)="onSubmit()" *ngIf="ConfirmbtnLabel">
          {{ConfirmbtnLabel}}
      </button>
  </div>
</div>